import React, { useState, useEffect, useRef, useContext, useId } from 'react';
import axios from 'axios';
import { GlobalContext } from '../../context/GlobalContext';
//import Popup from '../popup/Popup';
// import LocateMergeTranslationTBL from './LocateMergeTranslationTBL';
import LocatMergeTranslationUpdate from './LocatMergeTranslationUpdate';
import Select from 'react-select';
import SelectInput from '../../components/select/SelectInput';
// import DatabaseDropdown from '../../components/dropdown/DatabaseDropdown';
import { toast } from 'react-toastify';

const Locate = () => {
  const locateGeneratedId = useId();
  const locateId = `locate-${locateGeneratedId}`;

  const { API_URL, showToast } = useContext(GlobalContext);
  const [domainOptions, setDomainOptions] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [urlOptions, setUrlOptions] = useState([]);
  const [selectedURL, setSelectedURL] = useState("");
  const [refIDtext, setRefIDText] = useState("");
  const [data, setData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  // eslint-disable-next-line
  const [selectAll, setSelectAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [joinedText, setJoinedText] = useState("");
  const [isLoadingDomains, setIsLoadingDomains] = useState(false);
  const [isLoadingUrls, setIsLoadingUrls] = useState(false);
  const textAreaRef = useRef(null);
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  }, [refIDtext]);

  // Step 1: Load domains on component mount
  useEffect(() => {
    loadDomains();
    // eslint-disable-next-line
  }, []);


  const loadDomains = async () => {
    setUrlOptions([]);
    setSelectedURL("");

    setIsLoadingDomains(true);
    try {
      const response = await axios.get(`${API_URL}/filterDomain`);
      setDomainOptions(
        response.data.map(x => ({
          label: x.domain,
          value: x.domain
        }))
      );
      setUrlOptions([]);
      setSelectedURL("");
    } catch (error) {
      console.log(error);
      showToast('error', 'Failed to load domains', 'top', 5);
      setDomainOptions([]);
    } finally {
      setIsLoadingDomains(false);
    }
  };

  // Step 2: Load URLs when domain is selected
  const loadURLs = async (domain) => {
    if (!domain) {
      setUrlOptions([]);
      setSelectedURL("");
      return;
    }

    setIsLoadingUrls(true);
    try {
      const response = await axios.get(`${API_URL}/filterCurrentURL/${encodeURIComponent(domain)}`
      );
      const urlList = response.data.map(x => ({
        label: x.cur_url,
        value: x.cur_url
      }));
      const allurlList = [{ label: "All", value: "all" }, ...urlList,];
      setUrlOptions(allurlList);
      setSelectedURL("");
    } catch (error) {
      console.log(error);
      showToast('error', 'Failed to load URLs', 'top', 5);
      setUrlOptions([]);
    } finally {
      setIsLoadingUrls(false);
    }
  };

  const handleLocateMergeSearch = async () => {
    setData([])
    setSelectAll(false)
    setSelectedIds([])

    if (!selectedDomain || selectedDomain.trim() === '') {
      toast.error('Please select a Domain first!');
      return;
    }

    // if (!selectedURL || selectedURL.trim() === '') {
    //   toast.error('Please select a valid Script/URL!');
    //   return;
    // }

    if (!refIDtext || refIDtext.trim() === '') {
      toast.error('Please enter ref. ids....');
      return;
    }
    // === paylaod Proceed ===
    const formData = {
      ids: refIDtext,
      script: selectedURL,
      domain: selectedDomain,
    };

    const toastId = toast.loading('Processing, Please wait...');

    try {
      const response = await axios.post(`${API_URL}/LocateMergeSearch`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.length > 0 && response.status === 200) {
        toast.update(toastId, {
          render: "Data Fetch successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        setData(response.data);
        toast.dismiss()
        toast.success(`${response.data.length} record(s) found & loaded!`);
      } else if (response.data.length === 0) {
        setData([]);
        toast.dismiss()
        toast.error('No records found for the given IDs.');
        console.error('Error searching database');
      } else {
        toast.error(response.message || 'Search failed. Please try again.');
        console.error('API Error:', response);
        toast.dismiss()
      }
    } catch (error) {
      toast.error('Network error. Please check your connection and try again.');
      console.error('Error searching database:', error);
      toast.dismiss()
    }
  };

  const handleSelectAll = () => {
    const currentPageIds = data.map(item => item.id);
    const allSelected = currentPageIds.every(id => selectedIds.includes(id));

    if (allSelected) {
      setSelectedIds(selectedIds.filter(id => !currentPageIds.includes(id)));
    } else {
      setSelectedIds([...selectedIds, ...currentPageIds]);
    }
  };


  // eslint-disable-next-line
  const handleRemoveText = (indexToRemove) => {
    setSelectedIds((prevSelectedIds) => {
      const updatedSelectedIds = prevSelectedIds.filter((_, index) => index !== indexToRemove);
      return updatedSelectedIds;
    });
  };

  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const UpdateSiblingsHandle = async () => {
    const selectedData = data.filter((item) => selectedIds.includes(item.id));
    console.log("selectedData: ", selectedData);

    // === paylaod Proceed ===
    const jsonData = {
      domain: selectedDomain,
      selectedData: selectedData
    }

    setIsLoading(true);

    try {
      // Call the backend API
      const response = await axios.post(`${API_URL}/insertSiblings`, jsonData);

      if (response.data.message && response.status === 200) {
        // Display success message
        toast.success(response.data.message, {
          autoClose: false
        });
        // await handleLocateMergeSearch();
        // Get updated data from the API response
        setSelectedIds([]);
      } else {
        toast.error('Update failed. Please try again.');
      }
    } catch (error) {
      console.log("Error in MergedHandle:", error);
      toast.error('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };



  // const SetParentMD5Handle = async () => {
  //   const selectedData = data.filter((item) => selectedIds.includes(item.id));
  //   console.log("selectedData: ", selectedData);
  //   setIsLoading(true)
  //   showToast('pending', 'Processing, Please wait...', 'top', 10);

  //   // === paylaod Proceed ===
  //   const jsonData = {
  //     domain: selectedDomain,
  //     selectedData: selectedData
  //   }

  //   try {
  //     const response = await axios.post(`${API_URL}/markParentMD5`, jsonData, selectedData);

  //     // Log success message from API
  //     console.log("API Response:", response.data.message);

  //     if (response.data.message && response.status === 200) {
  //       showToast('success', response.data.message, 'top', 10);
  //       await handleLocateMergeSearch();
  //       setSelectedIds([]);
  //     } else {
  //       showToast('error', 'Update failed. Please try again.', 'top', 10);
  //     }

  //   } catch (error) {
  //     console.error("Error updating data:", error);
  //     alert("Failed to update data. Please try again.");
  //   } finally { setIsLoading(false) }
  // };

  useEffect(() => {
    const selectedTexts = data.filter((item) => selectedIds.includes(item.id)).sort((a, b) => {
      const partA = a.part || "";
      const partB = b.part || "";

      if (partA === partB) {
        return (a.seq || 0) - (b.seq || 0);
      }
      return String(partA).localeCompare(String(partB));
    })
      .map((item) => item.cleantxt || "");

    setJoinedText(selectedTexts);
  }, [selectedIds, data]);



  const handleDomainChange = (selectedOption) => {
    const domain = selectedOption ? selectedOption.value : '';
    setSelectedDomain(domain);
    loadURLs(domain);
  };

  const handleURLChange = (selectedOption) => {
    setSelectedURL(selectedOption ? selectedOption.value : '');
  };

  // Critical: Force full width + exact Bootstrap look
  const selectStyles = {
    control: (base) => ({
      ...base,
      height: '38px',
      minHeight: '38px',
      border: '1px solid #ced4da',
      borderRadius: '0.375rem',
      boxShadow: 'none',
      '&:hover': { borderColor: '#adb5bd' },
    }),
    '&:hover': {
      borderColor: '#adb5bd',
    },

    valueContainer: (base) => ({
      ...base,
      padding: '0 8px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '38px',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  return (
    <>
      <div className="container-fluid py-0">
        <div className="row g-3 align-items-end">
          {/* Domain - FULL WIDTH */}
          <div className="col-md-3">
            <label className="form-label">Select Domain</label>
            <div className="w-100">
              <SelectInput
                options={domainOptions}
                isSearchable
                isClearable
                value={domainOptions.find(o => o.value === selectedDomain) || null}
                onChange={handleDomainChange}
                placeholder={isLoadingDomains ? "Loading domains..." : "Search domain..."}
                noOptionsMessage={() => isLoadingDomains ? 'No domains found' : 'Select database first'}
                isDisabled={!isLoadingDomains}
                isLoading={isLoadingDomains}
              />
            </div>
          </div>

          {/* URL - FULL WIDTH */}
          <div className="col-md-4">
            <label className="form-label">Select URL</label>
            <div className="w-100">
              <Select
                options={urlOptions}
                value={urlOptions.find(o => o.value === selectedURL) || null}
                onChange={handleURLChange}
                placeholder={isLoadingUrls ? "Loading URLs..." : "Search URL..."}
                isSearchable
                isClearable
                isDisabled={!selectedDomain || isLoadingUrls}
                isLoading={isLoadingUrls}
                styles={selectStyles}
                classNamePrefix="react-select"
                noOptionsMessage={() => selectedDomain ? "No URL found" : "Select domain first"}
              />
            </div>
          </div>

          {/* Text Input - FULL WIDTH & SAME HEIGHT */}
          <div className="col-md-3">
            <label className="form-label">Enter Reference IDs</label>
            <input
              ref={textAreaRef}
              type="text"
              className="form-control fixed-height-input"
              placeholder="ex. 220, 221 or 220-222"
              value={refIDtext}
              onChange={(e) => setRefIDText(e.target.value)}
              style={{ height: '38px' }}
            />
          </div>

          <div className="col-md-1">
            <button
              id={`${locateId}-search`}
              className="btn btn-primary w-100 shadow-sm"
              onClick={handleLocateMergeSearch}
              style={{ height: '38px' }}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      {selectedIds.length > 0 ? (
        <div className="container mb-2 mt-3 border shadow-lg py-3 rounded">
          {joinedText.map((sentence, index) => (
            <span
              className="ps-0 py-1 fs-3 mt-1 mb-2 me-2"
              key={index}
              style={{
                backgroundColor: index % 2 === 1 ? "pink" : "#89CFF0",
              }}
            >
              {(sentence || "").trim()}
            </span>
          ))}
        </div>
      ) : (
        ""
      )}


      {/* {selectedIds.length > 0 ? <div className="container mb-2 mt-3 border shadow-lg p-3 bg-pink fs-5 rounded">{joinedText || "None"} </div> : ""} */}

      <div className="container ms-3 mb-2 mt-2">
        <div className="d-flex justify-content-end">
          <div className="d-flex justify-content-end">
            {selectedIds.length > 1 && (
              <button id={`${locateId}-sibling-update`} className="btn btn-primary border px-4 py-2 fs-5" onClick={UpdateSiblingsHandle}>
                {isLoading ? ("Processing, Please wait...") : ('Update Sibling Records')}
              </button>
            )}
            {/* {selectedIds.length === 1 && (
              <button className="btn btn-primary border" onClick={SetParentMD5Handle}>
                {isLoading ? ("Processing, Please wait...") : ('Mark Parent MD5')}
              </button>
            )} */}
          </div>
        </div>
      </div>

      {data.length > 0 ?
        <div className="container-fluid mb-2">
          <LocatMergeTranslationUpdate
            locateId={locateId}
            currentPosts={data}
            setFilterData={setData}
            filterData={data}
            setData={setData}
            handleCheckboxChange={handleCheckboxChange}
            selectedIds={selectedIds}
            selectAll={selectAll}
            handleSelectAll={handleSelectAll}
            selectedDomain={selectedDomain}
          />
        </div>
        :
        <div className='container-fluid mb-2 mt-2 text-center'>
          <table id="" className="table table-bordered border" style={{ color: "#222" }}>
            <tbody>
              <tr>
                <td className='fs-6 fw-lighter'>No results to display</td>
              </tr>
            </tbody>
          </table>
        </div>
      }



    </>
  );
};

export default Locate;
